import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from './env.service';
export interface TransferToUnitsData {
  userId: string;                // ID del usuario que realiza la transferencia (obligatorio)
  remittalComment?: string;      // Comentario de remisión (opcional)
  copyFiles?: boolean;           // Si se deben copiar archivos (opcional, default true)
};
export interface ReturnFromDestinationData {
  userId: string; // ID del usuario que realiza la devolución (requerido)
  reason?: string; // Motivo de la devolución/rechazo (opcional)
  restoreOriginal?: boolean; // Si se debe restaurar el caso original (opcional, default true)
}

@Injectable({
  providedIn: 'root'
})
export class TransferCaseService {
  private apiUrl: string;

  constructor(private http: HttpClient, private env: EnvService) {
    this.apiUrl = this.env.URL_API_V1;
  }

  /**
   * Autoriza o valida la remisión de un caso a una unidad destino.
   * @param caseId ID del caso
   * @param targetUnitId ID de la unidad destino
   * @param data Información adicional (usuario, validaciones, etc.)
   */
  transferToUnits(caseId: string, targetUnitId: string, data: TransferToUnitsData): Observable<any> {
    const url = `${this.apiUrl}/case/transfer/transfer-to-units/${caseId}/${targetUnitId}`;
    return this.http.post(url, data);
  }

  /**
   * Permite que la unidad destino devuelva o rechace la copia remitida de un caso.
   * @param caseId ID del caso
   * @param data Detalles del motivo de devolución u otra información relevante
   */
  returnCase(caseId: string, data: ReturnFromDestinationData): Observable<any> {
    const url = `${this.apiUrl}/case/transfer/return/${caseId}`;
    return this.http.post(url, data);
  }
}
